/**
 * FOSSA Global Color Variables
 *
 * These can be imported and used in places where you are need to add inline styles.
 * Note that inline styling is discouraged, try adding styles in Less instead.
 */
const COLORS = {
  // Primary colors
  fossaGreen: '#289E6D',
  fossaSlateBlue: '#3E485B',
  fossaWhite: '#FFF',
  fossaWhiteSmoke: '#F4F5F6',
  fossaBlack: '#000',
  fossaMidnightBlue: '#06132D',
  //  TextColors
  textColorPrimary: '#06132D', // @fossaMidnightBlue
  textColorSecondary: '#3E485B', // @fossaSlateBlue
  textColorAlternate: '#FFF', // @fossaWhite
  //  Secondary colors
  fossaCyan: '#0096E2',
  fossaBlue: '#1F60E0',
  fossaPurple: '#5429DD',
  fossaPink: '#ED217C',
  fossaRed: '#E71D36',
  fossaOrange: '#F6511D',
  fossaYellow: '#EE9900',
  // Gray
  fossaGray02: '#F5F5FA',
  fossaGray05: '#F3F3F5',
  fossaGray10: '#E6E7EA',
  fossaGray20: '#CDD0D5',
  fossaGray40: '#9BA1AB',
  fossaGray60: '#6A7181',
  fossaGray80: '#384257',
  fossaGray90: '#1E2A42',
  // Red
  fossaRed05: '#FAF5F7',
  fossaRed10: '#FDE8EB',
  fossaRed20: '#FAD2D7',
  fossaRed40: '#F5A5AF',
  fossaRed60: '#F17786',
  fossaRed80: '#EC4A5E',
  fossaRed110: '#D01A31',
  fossaRed120: '#B9172B',
  fossaRed180: '#33152F',
  // Orange
  fossaOrange05: '#FFF6F4',
  fossaOrange10: '#FEEDE8',
  fossaOrange20: '#FDDCD2',
  fossaOrange40: '#FBB9A5',
  fossaOrange60: '#FA9777',
  fossaOrange80: '#F8744A',
  fossaOrange110: '#DD491A',
  fossaOrange120: '#C54117',
  // Yellow
  fossaYellow05: '#FCEBCC',
  fossaYellow10: '#FDF5E5',
  fossaYellow20: '#FCEBCC',
  fossaYellow40: '#F8D699',
  fossaYellow60: '#F5C266',
  fossaYellow80: '#F1AD33',
  fossaYellow110: '#D68A00',
  fossaYellow120: '#BE7A00',
  // Green
  fossaGreen05: '#F4FAF8',
  fossaGreen10: '#E9F5F0',
  fossaGreen20: '#D4ECE2',
  fossaGreen40: '#A9D8C5',
  fossaGreen60: '#7EC5A7',
  fossaGreen80: '#53B18A',
  fossaGreen110: '#248E62',
  fossaGreen120: '#207E57',
  // Blue
  fossaBlue05: '#F4F7FD',
  fossaBlue10: '#E9EFFC',
  fossaBlue20: '#D2DFF9',
  fossaBlue40: '#A5BFF3',
  fossaBlue60: '#79A0EC',
  fossaBlue80: '#4C80E6',
  fossaBlue110: '#1C56CA',
  fossaBlue120: '#194DB3',
  // Purple
  fossaPurple05: '#F6F4FD',
  fossaPurple10: '#EEE9FC',
  fossaPurple20: '#DDD4F8',
  fossaPurple40: '#BBA9F1',
  fossaPurple60: '#987FEB',
  fossaPurple80: '#7654E4',
  fossaPurple110: '#4C25C7',
  fossaPurple120: '#4321B1',
  // Cyan
  fossaCyan05: '#F2FAFE',
  fossaCyan10: '#E5F4FC',
  fossaCyan20: '#CCEAF9',
  fossaCyan40: '#99D5F3',
  fossaCyan60: '#66C0EE',
  fossaCyan80: '#33ABE8',
  fossaCyan110: '#0087CB',
  fossaCyan120: '#0078B5',
  // Pink
  fossaPink05: '#FEF4F8',
  fossaPink10: '#FDE9F2',
  fossaPink20: '#FBD3E5',
  fossaPink40: '#F8A6CB',
  fossaPink60: '#F47AB0',
  fossaPink80: '#F14D96',
  fossaPink110: '#D51E70',
  fossaPink120: '#BE1A63',

} as const;

export type FOSSAColorName = keyof typeof COLORS;
export type FOSSAColor = typeof COLORS[FOSSAColorName];

export default COLORS;
